// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--AK6jo","column":"_93444fe79c--column--DOolJ"};